import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { setTemplateData } from '../../app/EditorSlice';
import { padServices } from '../../api';
import { Modal, message, Switch } from 'antd';
import { CheckOutlined, CloseOutlined, PlayCircleOutlined, PauseCircleOutlined } from '@ant-design/icons';
import MyHeader from '../Header/Header.module.css';
import './TemplateActiveToggle.css';

const TemplateActiveToggle = ({ viewMode = 'switch', onMenuClick }) => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const templateData = useSelector((state) => state.editor.templateData);
    const [isActive, setIsActive] = useState(templateData?.isActive);

    useEffect(() => {
        setIsActive(templateData?.isActive);
    }, [templateData?.isActive]);

    const handleToggle = async (newActiveStatus) => {
        const statusText = newActiveStatus ? 'activate' : 'deactivate';
        Modal.confirm({
            title: `${statusText.charAt(0).toUpperCase() + statusText.slice(1)} Template`,
            content: `Are you sure you want to ${statusText} this template?`,
            okText: statusText.charAt(0).toUpperCase() + statusText.slice(1),
            cancelText: 'Cancel',
            onOk: async () => {
                try {
                    if (id) {
                        const res = await padServices.updateTemplate({ templateId: id, data: { isActive: newActiveStatus?.toString() }, dispatch });
                        dispatch(setTemplateData(res.data.data));
                        setIsActive(res?.data?.data?.isActive ?? newActiveStatus);
                        message.success(`Template ${statusText}d successfully.`);
                    }
                } catch (e) {
                    console.error('Error in onOk:', e);
                    message.error(`Failed to ${statusText} the template. Please try again.`);
                }
            },
        });
    };

    if (viewMode === 'menu') {
        const icon = isActive ? <PauseCircleOutlined className="toggle-menu-icon" /> : <PlayCircleOutlined className="toggle-menu-icon" />;
        const text = isActive ? 'Deactivate Template' : 'Activate Template';
        return (
            <div className='menu-item' onClick={() => { onMenuClick && onMenuClick(); handleToggle(!isActive); }}>
                {icon}
                <span>{text}</span>
            </div>
        );
    }

    return (
        <div className='customSwitch'>
            <Switch
                className="template-switch"
                checked={isActive}
                onChange={handleToggle}
                checkedChildren={<CheckOutlined />}
                unCheckedChildren={<CloseOutlined />}
                title={templateData?.isActive ? 'Deactivate Template' : 'Activate Template'}
            />
        </div>
    );
};

export default TemplateActiveToggle;